export const generateKPIDetails = ({ kpiDetails, filteredData, alertType, customCounters = {} }) => {
  const kpiObj = kpiDetails?.map(kpi => ({ ...kpi }));

  if (!kpiObj || !filteredData) return kpiObj;

  const alertHandlers = {

    'Agile OR': (data) => {
      kpiObj[0].value = new Set(
        data?.filter(item => item["Basepack code"]).map(item => item["Basepack code"])
      ).size;
      kpiObj[1].value = new Set(
        data?.filter(item => item["CBU code"]).map(item => item["CBU code"])
      ).size;
      kpiObj[2].value = new Set(
        data
          ?.filter(item => ["High", 'P1',"Prio 1", "Prio1"].includes(item["Priority"]) && item["CBU code"])
          .map(item => item["CBU code"])
      ).size;
      kpiObj[3].value = data?.length;
      kpiObj[4].total = data?.length;
      kpiObj[4].closed = data?.filter(item => item["Alert status"] === "Open").length;
      kpiObj[4].values.Overdue = data?.filter(item => item["Alert status"] === "Overdue").length;
      kpiObj[4].values.Closed = data?.filter(item => item["Alert status"] === "Closed").length;
      kpiObj[4].values.Accepted = data?.filter(item => item["Alert status"] === "Accepted").length;
      kpiObj[4].values.Total = data?.length;
    },
    'Manpower Shortage': (data) => {
      kpiObj[0].value = data?.length;
      kpiObj[1].value = data?.length;
      kpiObj[2].values["Week N+4"] = 20;
      kpiObj[2].values["Week N+3"] = 30;
      kpiObj[2].values["Week N+2"] = 40;
      kpiObj[2].values["Week N+1"] = 5;
    }
  };

  if (alertHandlers[alertType]) {
    alertHandlers[alertType](filteredData);
  }

  Object.entries(customCounters).forEach(([key, value]) => {
    const kpiIndex = kpiObj.findIndex(item => item.label === key);
    if (kpiIndex !== -1) {
      kpiObj[kpiIndex].value = value;
    }
  });

  return kpiObj;
};
